import { useFm } from '@better-bit-fe/base-hooks';
import { Tooltip } from 'antd';
import styles from './index.module.less';
import getConfig from 'next/config';
import Cookie from 'js-cookie';
import { getLang } from '@better-bit-fe/base-utils';

const { staticFolder } = getConfig().publicRuntimeConfig;

const DownloadIcons = ({ dark = false }) => {
  const t = useFm();

  const handleDownApk = () => {
    const downNode = window.parent.document.getElementById('downloadFrame');
    if (downNode) {
      window.parent.document.body.removeChild(downNode);
    }
    const newDownNode = window.parent.document.createElement('iframe');
    newDownNode.setAttribute('id', 'downloadFrame');
    window.parent.document.body.append(newDownNode);
    newDownNode.src = `https://www.mufex.finance/static/app/files/mainnet/Mufex.finance.apk?t=${Date.now()}`;
    newDownNode.style.display = 'none';
  };

  const gotoGooglePlay = () => {
    const refferCode =
      new URLSearchParams(window.location.search).get('inviteCode') ||
      Cookie.get('invite_code');
    if (refferCode) {
      location.href = `https://play.google.com/store/apps/details?id=co.mufex.org&referrer=${refferCode}`;
    } else {
      location.href = `https://play.google.com/store/apps/details?id=co.mufex.org`;
    }
  };
  const gotoTestFlight = () => {
    const isCN = getLang().includes('zh');
    location.href = isCN
      ? 'https://docs.mufex.finance/mufex/v/zhong-wen/support/ru-he-an-zhuang-mufex-ios-testflight-ban-ben'
      : 'https://docs.mufex.finance/mufex/support/install-mufex-through-the-app-store/how-to-install-mufex-ios-testflight';
  };
  const gotoApple = () => {
    const isCN = getLang().includes('zh');
    location.href = isCN
      ? 'https://docs.mufex.finance/mufex/v/zhong-wen/support/tong-guo-app-store-an-zhuang-mufex'
      : 'https://docs.mufex.finance/mufex/support/install-mufex-through-the-app-store';
  };
  const qrcodeContent = (
    <div>
      <div className={styles.text}>{t('scanQrcode')}</div>
      <img
        src={`${staticFolder}/mufex/images/downloadApp/mufexQrcode.png`}
      ></img>
    </div>
  );
  return (
    <div className={styles.downIcons}>
      {/* google应用市场 */}
      <div
        className={dark ? styles.darkIcon : styles.icon}
        onClick={gotoGooglePlay}
      >
        <svg
          width="52"
          height="52"
          viewBox="0 0 52 52"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7341 36.4994L25.5529 27.0495L29.0151 30.3803L17.3416 36.6242C16.8975 36.8628 16.3524 36.8574 15.914 36.6133C15.914 36.6187 15.7341 36.4994 15.7341 36.4994ZM24.5637 26.0948L15.2002 35.1052V17.0843L24.5637 26.0948ZM30.4146 22.3734L34.9895 24.82C35.4392 25.0586 35.7202 25.5143 35.7202 26.0025C35.7202 26.4908 35.4392 26.9464 34.9895 27.1851L30.2909 29.6968L26.5477 26.0948C26.5421 26.0948 30.4146 22.3734 30.4146 22.3734ZM15.6273 15.5925C15.7116 15.5165 15.8072 15.446 15.9084 15.3864C16.3468 15.1422 16.8919 15.1368 17.3359 15.3755L29.1387 21.6899L25.5529 25.14L15.6273 15.5925Z"
          />
          <rect x="0.5" y="0.5" width="51" height="51" rx="15.5" />
        </svg>
      </div>
      {/* 安卓apk */}
      <div
        className={dark ? styles.darkIcon : styles.icon}
        onClick={handleDownApk}
      >
        <svg
          width="52"
          height="52"
          viewBox="0 0 52 52"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.306 19.5396C16.6489 19.2122 17.2048 19.2122 17.5477 19.5396L20.4201 22.2817C22.087 21.4444 23.9856 20.9705 26 20.9705C28.0144 20.9705 29.913 21.4444 31.5799 22.2817L34.4523 19.5396C34.7952 19.2122 35.3511 19.2122 35.694 19.5396C36.0369 19.8669 36.0369 20.3977 35.694 20.725L33.1069 23.1948C36.0745 25.2804 38 28.6387 38 32.4264C38 32.5198 37.9988 32.613 37.9965 32.7058H14.0035C14.0012 32.613 14 32.5198 14 32.4264C14 28.6387 15.9255 25.2804 18.8931 23.1948L16.306 20.725C15.9631 20.3977 15.9631 19.8669 16.306 19.5396ZM21.3171 28.7941C21.9637 28.7941 22.4878 28.2937 22.4878 27.6764C22.4878 27.0592 21.9637 26.5588 21.3171 26.5588C20.6705 26.5588 20.1463 27.0592 20.1463 27.6764C20.1463 28.2937 20.6705 28.7941 21.3171 28.7941ZM31.8537 27.6764C31.8537 28.2937 31.3295 28.7941 30.6829 28.7941C30.0363 28.7941 29.5122 28.2937 29.5122 27.6764C29.5122 27.0592 30.0363 26.5588 30.6829 26.5588C31.3295 26.5588 31.8537 27.0592 31.8537 27.6764Z"
          />
          <rect x="0.5" y="0.5" width="51" height="51" rx="15.5" />
        </svg>
      </div>
      {/* Apple ios*/}
      <div className={dark ? styles.darkIcon : styles.icon} onClick={gotoApple}>
        <svg
          width="52"
          height="53"
          viewBox="0 0 52 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.8654 16.5885C28.4525 14.5101 30.659 14.5 30.659 14.5C30.659 14.5 30.9872 16.4541 29.4104 18.3364C27.7269 20.3464 25.8133 20.0175 25.8133 20.0175C25.8133 20.0175 25.454 18.4367 26.8654 16.5885ZM26.0152 21.3863C26.8317 21.3863 28.347 20.2712 30.3195 20.2712C33.7148 20.2712 35.0505 22.6716 35.0505 22.6716C35.0505 22.6716 32.4381 23.9986 32.4381 27.2187C32.4381 30.8511 35.6924 32.103 35.6924 32.103C35.6924 32.103 33.4175 38.4648 30.3448 38.4648C28.9335 38.4648 27.8363 37.5198 26.3493 37.5198C24.8339 37.5198 23.3301 38.5 22.3507 38.5C19.5448 38.5001 16 32.4653 16 27.6143C16 22.8417 19.0005 20.338 21.8148 20.338C23.6443 20.338 25.064 21.3863 26.0152 21.3863Z"
            fill="white"
          />
          <rect x="0.5" y="1" width="51" height="51" rx="15.5" stroke="white" />
        </svg>
      </div>
      {/* Apple testflight */}
      <div
        className={dark ? styles.darkIconTestFlight : styles.iconTestFlight}
        onClick={gotoTestFlight}
      >
        <svg
          width="52"
          height="53"
          viewBox="0 0 52 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2739_27725)">
            <path
              d="M26.8654 12.5885C28.4525 10.5101 30.659 10.5 30.659 10.5C30.659 10.5 30.9872 12.4541 29.4104 14.3364C27.7269 16.3464 25.8133 16.0175 25.8133 16.0175C25.8133 16.0175 25.454 14.4367 26.8654 12.5885ZM26.0152 17.3863C26.8317 17.3863 28.347 16.2712 30.3195 16.2712C33.7148 16.2712 35.0505 18.6716 35.0505 18.6716C35.0505 18.6716 32.4381 19.9986 32.4381 23.2187C32.4381 26.8511 35.6924 28.103 35.6924 28.103C35.6924 28.103 33.4175 34.4648 30.3448 34.4648C28.9335 34.4648 27.8363 33.5198 26.3493 33.5198C24.8339 33.5198 23.3301 34.5 22.3507 34.5C19.5448 34.5001 16 28.4653 16 23.6143C16 18.8417 19.0005 16.338 21.8148 16.338C23.6443 16.338 25.064 17.3863 26.0152 17.3863Z"
              fill="white"
            />
            <path
              d="M52 39.5V68.5H-1V39.5H52Z"
              fill="url(#paint0_linear_2739_27725)"
            />
            <path
              d="M11.0463 47.5V43.1495H9.3698V42.46H13.4543V43.1495H11.7778V47.5H11.0463ZM15.1304 47.605C14.7547 47.605 14.4245 47.5233 14.1399 47.36C13.8575 47.1943 13.637 46.9645 13.4784 46.6705C13.322 46.3742 13.2439 46.0312 13.2439 45.6415C13.2439 45.2285 13.3209 44.8703 13.4749 44.567C13.6312 44.2637 13.8482 44.0292 14.1259 43.8635C14.4035 43.6978 14.7267 43.615 15.0954 43.615C15.4804 43.615 15.8082 43.7048 16.0789 43.8845C16.3495 44.0618 16.5514 44.315 16.6844 44.644C16.8197 44.973 16.8734 45.3638 16.8454 45.8165H16.1139V45.5505C16.1092 45.1118 16.0252 44.7875 15.8619 44.5775C15.7009 44.3675 15.4547 44.2625 15.1234 44.2625C14.757 44.2625 14.4817 44.378 14.2974 44.609C14.113 44.84 14.0209 45.1737 14.0209 45.61C14.0209 46.0253 14.113 46.3473 14.2974 46.576C14.4817 46.8023 14.7477 46.9155 15.0954 46.9155C15.324 46.9155 15.5212 46.8642 15.6869 46.7615C15.8549 46.6565 15.9855 46.5072 16.0789 46.3135L16.7964 46.541C16.6494 46.8793 16.4265 47.1418 16.1279 47.3285C15.8292 47.5128 15.4967 47.605 15.1304 47.605ZM13.7829 45.8165V45.246H16.4814V45.8165H13.7829ZM19.0761 47.6015C18.6165 47.6015 18.242 47.5 17.9526 47.297C17.6633 47.094 17.486 46.8082 17.4206 46.4395L18.1696 46.324C18.2163 46.52 18.3236 46.6752 18.4916 46.7895C18.662 46.9015 18.8731 46.9575 19.1251 46.9575C19.3538 46.9575 19.5323 46.9108 19.6606 46.8175C19.7913 46.7242 19.8566 46.5958 19.8566 46.4325C19.8566 46.3368 19.8333 46.2598 19.7866 46.2015C19.7423 46.1408 19.6478 46.0837 19.5031 46.03C19.3585 45.9763 19.138 45.9098 18.8416 45.8305C18.5173 45.7465 18.2595 45.6567 18.0681 45.561C17.8791 45.463 17.7438 45.3498 17.6621 45.2215C17.5828 45.0908 17.5431 44.9333 17.5431 44.749C17.5431 44.5203 17.6038 44.3208 17.7251 44.1505C17.8465 43.9802 18.0168 43.8483 18.2361 43.755C18.4578 43.6617 18.7168 43.615 19.0131 43.615C19.3025 43.615 19.5603 43.6605 19.7866 43.7515C20.013 43.8425 20.1961 43.972 20.3361 44.14C20.4761 44.3057 20.5601 44.5005 20.5881 44.7245L19.8391 44.861C19.8135 44.679 19.7283 44.5355 19.5836 44.4305C19.439 44.3255 19.2511 44.2683 19.0201 44.259C18.7985 44.2497 18.6188 44.287 18.4811 44.371C18.3435 44.4527 18.2746 44.5658 18.2746 44.7105C18.2746 44.7945 18.3003 44.8657 18.3516 44.924C18.4053 44.9823 18.508 45.0383 18.6596 45.092C18.8113 45.1457 19.0353 45.2098 19.3316 45.2845C19.649 45.3662 19.901 45.4572 20.0876 45.5575C20.2743 45.6555 20.4073 45.7733 20.4866 45.911C20.5683 46.0463 20.6091 46.2108 20.6091 46.4045C20.6091 46.7778 20.4726 47.0707 20.1996 47.283C19.929 47.4953 19.5545 47.6015 19.0761 47.6015ZM23.5466 47.5C23.3086 47.5467 23.0752 47.5665 22.8466 47.5595C22.6179 47.5525 22.4137 47.5082 22.2341 47.4265C22.0544 47.3448 21.9191 47.2165 21.8281 47.0415C21.7464 46.8852 21.7021 46.7265 21.6951 46.5655C21.6904 46.4022 21.6881 46.2178 21.6881 46.0125V42.67H22.4231V45.9775C22.4231 46.1292 22.4242 46.261 22.4266 46.373C22.4312 46.485 22.4557 46.5795 22.5001 46.6565C22.5841 46.8012 22.7171 46.884 22.8991 46.905C23.0834 46.9237 23.2992 46.9155 23.5466 46.8805V47.5ZM20.9636 44.308V43.72H23.5466V44.308H20.9636ZM24.3435 47.5V42.46H27.329V43.1915H25.075V44.6125H26.909V45.3475H25.075V47.5H24.3435ZM28.0297 47.5V42.355H28.7612V47.5H28.0297ZM29.8823 43.1005V42.39H30.6138V43.1005H29.8823ZM29.8823 47.5V43.72H30.6138V47.5H29.8823ZM33.2223 49.285C33.0193 49.285 32.8221 49.2535 32.6308 49.1905C32.4418 49.1275 32.2691 49.0342 32.1128 48.9105C31.9565 48.7892 31.827 48.6387 31.7243 48.459L32.3998 48.116C32.4815 48.277 32.5981 48.3948 32.7498 48.4695C32.9015 48.5442 33.0613 48.5815 33.2293 48.5815C33.437 48.5815 33.6143 48.5442 33.7613 48.4695C33.9083 48.3972 34.0191 48.2875 34.0938 48.1405C34.1708 47.9935 34.2081 47.8115 34.2058 47.5945V46.5375H34.2933V43.72H34.9408V47.6015C34.9408 47.7018 34.9373 47.7975 34.9303 47.8885C34.9233 47.9795 34.9105 48.0705 34.8918 48.1615C34.8381 48.4158 34.7355 48.6258 34.5838 48.7915C34.4345 48.9572 34.2431 49.0808 34.0098 49.1625C33.7788 49.2442 33.5163 49.285 33.2223 49.285ZM33.1663 47.605C32.814 47.605 32.5095 47.5175 32.2528 47.3425C31.9985 47.1675 31.8013 46.9295 31.6613 46.6285C31.5236 46.3252 31.4548 45.9845 31.4548 45.6065C31.4548 45.2262 31.5248 44.8867 31.6648 44.588C31.8048 44.287 32.0031 44.0502 32.2598 43.8775C32.5188 43.7025 32.8256 43.615 33.1803 43.615C33.5373 43.615 33.8371 43.7025 34.0798 43.8775C34.3248 44.0502 34.5091 44.287 34.6328 44.588C34.7588 44.889 34.8218 45.2285 34.8218 45.6065C34.8218 45.9845 34.7588 46.324 34.6328 46.625C34.5068 46.926 34.3213 47.1652 34.0763 47.3425C33.8313 47.5175 33.528 47.605 33.1663 47.605ZM33.2678 46.9435C33.5081 46.9435 33.7041 46.8863 33.8558 46.772C34.0075 46.6577 34.1183 46.5002 34.1883 46.2995C34.2583 46.0988 34.2933 45.8678 34.2933 45.6065C34.2933 45.3452 34.2571 45.1142 34.1848 44.9135C34.1148 44.7128 34.0051 44.5565 33.8558 44.4445C33.7088 44.3325 33.521 44.2765 33.2923 44.2765C33.0496 44.2765 32.8501 44.336 32.6938 44.455C32.5375 44.574 32.4208 44.7338 32.3438 44.9345C32.2691 45.1352 32.2318 45.3592 32.2318 45.6065C32.2318 45.8562 32.2691 46.0825 32.3438 46.2855C32.4208 46.4862 32.5351 46.646 32.6868 46.765C32.8408 46.884 33.0345 46.9435 33.2678 46.9435ZM38.5766 47.5V45.6415C38.5766 45.4945 38.5638 45.344 38.5381 45.19C38.5148 45.0337 38.4681 44.889 38.3981 44.756C38.3304 44.623 38.2336 44.5157 38.1076 44.434C37.9839 44.3523 37.8218 44.3115 37.6211 44.3115C37.4904 44.3115 37.3668 44.3337 37.2501 44.378C37.1334 44.42 37.0308 44.4888 36.9421 44.5845C36.8558 44.6802 36.7869 44.8062 36.7356 44.9625C36.6866 45.1188 36.6621 45.309 36.6621 45.533L36.2071 45.3615C36.2071 45.0185 36.2713 44.7163 36.3996 44.455C36.5279 44.1913 36.7123 43.986 36.9526 43.839C37.1929 43.692 37.4834 43.6185 37.8241 43.6185C38.0854 43.6185 38.3048 43.6605 38.4821 43.7445C38.6594 43.8285 38.8029 43.9393 38.9126 44.077C39.0246 44.2123 39.1098 44.3605 39.1681 44.5215C39.2264 44.6825 39.2661 44.84 39.2871 44.994C39.3081 45.148 39.3186 45.2833 39.3186 45.4V47.5H38.5766ZM35.9201 47.5V42.46H36.5746V45.1795H36.6621V47.5H35.9201ZM42.3932 47.5C42.1552 47.5467 41.9219 47.5665 41.6932 47.5595C41.4646 47.5525 41.2604 47.5082 41.0807 47.4265C40.9011 47.3448 40.7657 47.2165 40.6747 47.0415C40.5931 46.8852 40.5487 46.7265 40.5417 46.5655C40.5371 46.4022 40.5347 46.2178 40.5347 46.0125V42.67H41.2697V45.9775C41.2697 46.1292 41.2709 46.261 41.2732 46.373C41.2779 46.485 41.3024 46.5795 41.3467 46.6565C41.4307 46.8012 41.5637 46.884 41.7457 46.905C41.9301 46.9237 42.1459 46.9155 42.3932 46.8805V47.5ZM39.8102 44.308V43.72H42.3932V44.308H39.8102Z"
              fill="white"
            />
          </g>
          <rect x="0.5" y="1" width="51" height="51" rx="15.5" stroke="white" />
          <defs>
            <linearGradient
              id="paint0_linear_2739_27725"
              x1="32.5"
              y1="39.5"
              x2="32.5"
              y2="59.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#19B2EF" />
              <stop offset="1" stopColor="#176CE2" />
            </linearGradient>
            <clipPath id="clip0_2739_27725">
              <rect y="0.5" width="52" height="52" rx="16" />
            </clipPath>
          </defs>
        </svg>
      </div>
      {/* qrCode */}
      {/* @ts-ignore */}
      <Tooltip
        title={qrcodeContent}
        placement="bottom"
        overlayClassName={styles.tooltipQrcode}
      >
        <div className={dark ? styles.darkIcon : styles.icon}>
          <svg
            width="52"
            height="53"
            viewBox="0 0 52 53"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15 15.5H27.0041V27.4924H15V15.5ZM17.751 18.2483V24.7441H24.2531V18.2483H17.751Z"
              fill="#FAFAFA"
            />
            <path
              d="M22.9987 19.4933H18.9973V23.4908H22.9987V19.4933Z"
              fill="#FAFAFA"
            />
            <path
              d="M36.9999 24.9905H33.9988V27.9886H36.9999V24.9905Z"
              fill="#FAFAFA"
            />
            <path
              d="M31.9925 24.9905H28.9915V27.9886H31.9925V24.9905Z"
              fill="#FAFAFA"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28.9914 15.4999H36.9941V23.4948H28.9914V15.4999ZM31.7424 18.2482V20.7465H34.2431V18.2482H31.7424Z"
              fill="#FAFAFA"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28.9915 29.4985H36.9943V37.4935H28.9915V29.4985ZM31.7425 32.2469V34.7451H34.2432V32.2469H31.7425Z"
              fill="#FAFAFA"
            />
            <path
              d="M27.5008 29.4985H24.4998V32.4966H27.5008V29.4985Z"
              fill="#FAFAFA"
            />
            <path
              d="M27.5004 34.5017H24.4993V37.4998H27.5004V34.5017Z"
              fill="#FAFAFA"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.9998 29.4985H23.0026V37.4935H14.9998V29.4985ZM17.7509 32.2469V34.7451H20.2516V32.2469H17.7509Z"
              fill="#FAFAFA"
            />
            <rect
              x="0.5"
              y="1"
              width="51"
              height="51"
              rx="15.5"
              stroke="white"
            />
          </svg>
        </div>
      </Tooltip>
    </div>
  );
};

export default DownloadIcons;
